import type { FC } from "react";
import { ASSISTANT_AVATAR } from "../../../../../theme/tokens";

const { ACCESSORY } = ASSISTANT_AVATAR;

/** Worn around the neck, so it sits inside the portrait clip with the shoulders. */
export const HumanStethoscope: FC = () => (
	<>
		<path d="M44 93 Q45 106 56 109 M76 93 Q75 106 64 109" fill="none" stroke={ACCESSORY.INK} strokeWidth={2.6} strokeLinecap="round" />
		<circle cx={60} cy={110} r={4.6} fill={ACCESSORY.CHEST_PIECE} stroke={ACCESSORY.INK} strokeWidth={2.2} />
	</>
);
